<template>
	<div>
		<div class="userWrap">
			<p>注册时间：</p>
			<p>{{ user.create_time }}</p>
			<p>手机号码</p>
			<p>{{ user.phone }}</p>
			<p>密码</p>
			<el-button type="primary" style="width: fit-content;" @click="handleShowChangePasswordForm"
				size="small">修改密码</el-button>
		</div>
		<!-- 修改密码弹窗 -->
		<change-password :visible.sync="showChangePasswordForm"></change-password>
	</div>
</template>

<script>
import { getInfo } from '@/api/user'
import ChangePassword from './components/changePassword'
export default {
	name: 'TouristInfo',
	components: {
		ChangePassword
	},
	computed: {

	},
	data() {
		return {
			user: {},
			showChangePasswordForm: false
		}
	},
	created() {
		this.getInfo()
	},
	methods: {
		getInfo() {
			getInfo({}).then(response => {
				this.user = response.data
			}).catch(() => {

			})
		},
		handleShowChangePasswordForm() {
			this.showChangePasswordForm = true
		},
	}

}
</script>

<style lang="scss" scoped>
.userWrap {
	width: 100%;
	padding: 37px 75px 180px 75px;
	box-sizing: border-box;
	background-color: #f7f7f7f7;
	display: grid;
	grid-template-columns: 97px auto;
	column-gap: 15px;
	align-items: center;
	row-gap: 37px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	color: #303133;

	:nth-child(odd) {
		text-align: right;
	}
}
</style>
